<template>
  <div id="pdfContainer" ref="pdfContainer">
    <loading v-show="loadingActive"></loading>
    <iframe :src="urlSrc"></iframe>
    <div style="z-index:99999" class="returnfsty" @click="returnf">
      <p id="goBack">返回</p>
    </div>
  </div>
</template>

<script>
import { scanUrlapp } from "@/CommonDP/utils";
import loading from "@/CommonDP/components/loading/loading.vue";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  components: {
    loading
  },
  data() {
    return {
      loadingActive: true,
      urlSrc: ""
    };
  },

  async mounted() {
    const { f, n } = this.$route.query;
    document.title = n;
    const url = scanUrlapp(f);
    this.urlSrc = `./pdf/web/viewer.html?file=${encodeURIComponent(url)}`;
    this.initEvent();

    window.callBackError = () => {
      Toast("文档加载失败");
    };

    window.callBackSuccess = () => {
      this.loadingActive = false;
    };
  },

  methods: {
    returnf() {
      // var u = navigator.userAgent;
      // var goBack = document.getElementById("goBack");
      // // 针对ios原生浏览器处理
      // if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && /(Safari)/i.test(u)) {
      //   goBack.setAttribute(
      //     "onclick",
      //     "javascript:window.location=document.referrer;"
      //   );
      // } else {
      //   window.history.go(-1);
      // }
    },
    initEvent() {
      console.log("初始化监听事件");
      document.addEventListener("touchstart", this.touch2mouse, true);
      document.addEventListener("touchmove", this.touch2mouse, true);
      document.addEventListener("touchend", this.touch2mouse, true);
      // document.addEventListener("touchcancel", switch2touch, true);
    },

    touch2mouse(event) {
      var touches = event.changedTouches;
      var first = touches[0];
      var type = "";
      switch (event.type) {
        case "touchstart":
          type = "mousedown";
          break;
        case "touchmove":
          type = "mousemove";
          break;
        case "touchend":
          type = "mouseup";
          break;
        default:
          return;
      }

      var simulatedEvent = document.createEvent("MouseEvent");
      simulatedEvent.initMouseEvent(
        type,
        true,
        true,
        window,
        1,
        first.screenX,
        first.screenY,
        first.clientX,
        first.clientY,
        false,
        false,
        false,
        false,
        0 /* left*/,
        null
      );
      first.target.dispatchEvent(simulatedEvent);
      // event.preventDefault();
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#pdfContainer {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  .returnfsty {
    line-height: 48px;
    height: 48px;
    text-align: center;
    background: #fff;
    font-size: 16px;
    color: #616161;
    cursor: pointer;
    position: absolute;
    z-index: 9;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
